import { FormsEnum, MessagesEnum } from 'app/shared/enums';
import { QuotationState } from 'app/store/data/quotation';
import {
  setMessageVisibility,
  setShouldCheckIfConsentResetRequired,
} from 'app/services/businessFunctionHelpers';
import {
  ConsentResetPersonField,
  ConsentResetTrackedPerson,
  getConsentResetPersonGroup,
  shouldCheckConsentResetForTrackedPerson,
} from 'app/shared/helpers/checkAndResetMarketingConsent';
import { checkIsDataObfuscated } from './checkIsDataObfuscated';

type ResetTarget =
  | {
      type: 'root';
      field: 'email' | 'phoneNumber';
    }
  | {
      type: 'person';
      trackedPerson: ConsentResetTrackedPerson;
      field: ConsentResetPersonField;
    };

export function handleObfuscatedFieldConsentReset({
  value,
  initialRun,
  messageKey,
  formName,
  quotation,
  isOperator,
  resetTarget,
  forceHideMessage,
}: {
  value: string;
  initialRun?: boolean;
  messageKey: MessagesEnum;
  formName: FormsEnum;
  quotation: QuotationState;
  isOperator: boolean;
  resetTarget?: ResetTarget;
  forceHideMessage?: boolean;
}) {
  const isDataObfuscated = checkIsDataObfuscated(value, initialRun);

  setMessageVisibility({
    key: messageKey,
    visible: forceHideMessage ? false : isDataObfuscated,
    formName,
  });

  if (!resetTarget) {
    return;
  }

  if (
    !isDataObfuscated ||
    isOperator ||
    !quotation.consents?.marketing?.consent
  ) {
    return;
  }

  if (resetTarget.type === 'root') {
    setShouldCheckIfConsentResetRequired({
      [resetTarget.field]: true,
    });
    return;
  }

  const shouldTrackPerson = shouldCheckConsentResetForTrackedPerson(
    resetTarget.trackedPerson,
    quotation.insurantSelection
  );

  if (!shouldTrackPerson) {
    return;
  }

  const personGroup = getConsentResetPersonGroup(quotation.insurantSelection);

  setShouldCheckIfConsentResetRequired({
    [personGroup]: {
      [resetTarget.field]: true,
    },
  });
}
